var easing = {

	linear: function (t) { return t },

	// accelerating from zero velocity
	easeInQuad: function (t) { return t*t },
	// decelerating to zero velocity
	easeOutQuad: function (t) { return t*(2-t) },
	// acceleration until halfway, then deceleration
	easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
 
	// accelerating from zero velocity 
	easeInCubic: function (t) { return t*t*t },
	// decelerating to zero velocity 
	easeOutCubic: function (t) { return (--t)*t*t+1 },
	// acceleration until halfway, then deceleration 
	easeInOutCubic: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
 
	// accelerating from zero velocity 
	easeInQuart: function (t) { return t*t*t*t },
	// decelerating to zero velocity 
	easeOutQuart: function (t) { return 1-(--t)*t*t*t },
	// acceleration until halfway, then deceleration
	easeInOutQuart: function (t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
 
	// accelerating from zero velocity
	easeInQuint: function (t) { return t*t*t*t*t },
	// decelerating to zero velocity
	easeOutQuint: function (t) { return 1+(--t)*t*t*t*t },
	// acceleration until halfway, then deceleration 
	easeInOutQuint: function (t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t },
 
	// accelerating from zero velocity
	easeInSine: function (t) { return -1*Math.cos(t*(Math.PI/2))+1 },
	// decelerating to zero velocity
	easeOutSine: function (t) { return 1*Math.sin(t*(Math.PI/2)) },
	// accelerating until halfway, then decelerating
	easeInOutSine: function (t) { return -0.5*(Math.cos(Math.PI*t)-1) },
 
	// accelerating from zero velocity
	easeInExpo: function (t) { return 1*Math.pow(2, 10*(t-1)) },
	// decelerating to zero velocity
	easeOutExpo: function (t) { return 1*(-Math.pow(2, -10*t)+1 ) },
	// accelerating until halfway, then decelerating
	easeInOutExpo: function (t) { t /= 0.5; if (t < 1) return 0.5 * Math.pow(2, 10*(t-1)); t--; return 0.5 * (-Math.pow(2, -10*t)+2); },
 
	// accelerating from zero velocity
	easeInCirc: function (t) { return -1*(Math.sqrt(1-t*t)-1) },
	// decelerating to zero velocity
	easeOutCirc: function (t) { t--; return 1*Math.sqrt(1-t*t); },
	// acceleration until halfway, then deceleration
	easeInOutCirc: function (t) { t /= 0.5; if(t<1) { return -0.5*(Math.sqrt(1-t*t)-1); }else{ t-=2; return 0.5*(Math.sqrt(1-t*t)+1); } },
	
	easeInBack: function(t) { var s = 1.70158; return t * t * ((s+1)*t - s); },
	easeOutBack: function(t) { var s = 1.70158; t -= 1; return (t*t*((s+1)*t + s) + 1); },
	easeInOutBack: function(t) { var s = 1.70158; return (t/=0.5) < 1 ? 0.5*(t*t*(((s*=(1.525))+1)*t -s)) : 0.5*((t-=2)*t*(((s*=(1.525))+1)*t +s) +2); },
	
	easeInAtan: function(t) { var a = 15, m = Math.atan(a); return (Math.atan((t-1)*a)/m)+1; },
	easeOutAtan: function(t) { var a = 15, m = Math.atan(a); return Math.atan(t*a )/m; },
	easeInOutAtan: function(t) { var a = 15, b = .5, m = Math.atan(b*a); return (Math.atan((t-b)*a)/(2*m))+b; },
	
	easeOutElastic: function(t) { var p = 0.3; return Math.pow(2,-10*t) * Math.sin((t-p/4)*(2*Math.PI)/p) + 1; },
	
	easeOutBounce: function(t) {var n=1.70158,r=7.5625;return 1===t?1:4/11>t?1*r*t*t:8/11>t?-n*(1-(r*(t-6/11)*(t-6/11)+.75))+1:10/11>t?-n*(1-(r*(t-9/11)*(t-9/11)+.9375))+1:-n*(1-(r*(t-21/22)*(t-21/22)+.984375))+1;}

}